// TODO: Make starting values manageable for employees and participation

class RoiCalculator {
  constructor(element) {
    this.calculator = element;

    this.population = element.querySelector('.calculator__field--population');
    this.participation = element.querySelector(
      '.calculator__field--participation'
    );

    this.participants = element.querySelector(
      '.calculator__field--participants'
    );
    this.costPerParticipantTraditional = element.querySelector(
      '.calculator__field--total-cost-traditional'
    );
    this.annualCostSavings = element.querySelector(
      '.calculator__result--annual-cost-savings'
    );
    this.estimatedCostsTraditional = element.querySelector(
      '.calculator__result--estimated-costs-traditional'
    );
    this.estimatedCostsColor = element.querySelector(
      '.calculator__result--estimated-costs-color'
    );

    this.t2dCost = element.querySelector('.calculator__result--t2d-cost');
    this.t2dPercentage = element.querySelector(
      '.calculator__result--t2d-percentage'
    );
    this.hypertensionCost = element.querySelector(
      '.calculator__result--hypertension-cost'
    );
    this.hypertensionPercentage = element.querySelector(
      '.calculator__result--hypertension-percentage'
    );

    // Array of fields to be pre-filled
    this.additionalDetailsFieldNames = [
      'costPerPhysicianVisit',
      'numberOfPhysicianVisits',
      'bloodDrawFeeCost',
      'hga1cTestCost',
      'lipidPanelCost',
      'altTestCost',
      'astTestCost',
    ];

    this.digitsAndDots = /[^\d.]/g;

    // Bind this to for event listener
    this.performCalculations = this.performCalculations.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);

    // Add elements to this using the name
    this.additionalDetailsFieldNames.forEach((field) => {
      this[field] = this.calculator.querySelector(`#${field}`);
      this[field].addEventListener('input', this.performCalculations);
      this[field].addEventListener('focusin', this.handleFocusIn);
      this[field].addEventListener('focusout', this.handleFocusOut);
    });

    // Static initialValues
    this.initialValues = window.initialValues || {
      population: 100000,
      participation: .2,
      costPerPhysicianVisit: 75.33,
      numberOfPhysicianVisits: 1.4,
      bloodDrawFeeCost: 3,
      hga1cTestCost: 9.71,
      lipidPanelCost: 13.39,
      altTestCost: 5.3,
      astTestCost: 5.18,
      costPerParticipantHybridColor: 95,
    };

    // Static T2D numbers
    this.t2d = window.t2d || {
      annualIncrementalCostOfTreatingT2d: 10306,
      incidenceOfPrediabetes: 11.9,
      incidenceOfT2d: 1,
      averageProgressionOfPrediabetesToT2d: 25,
      participationInDiabetesPrevention: 55,
      effectivenessOfDiabetesPrevention: 58,
    };

    // Static hypertension numbers
    this.hypertension = window.hypertension || {
      annualIncrementalCostOfTreatingHypertension: 1920,
      incidenceOfPrehypertension: 20,
      incidenceOfHypertension: 2,
      averageProgressionOfPreToHypertension: 23,
      adherenceToCardiometabolicTxRegimen: 55,
      effectivenessOfHypertensionPrevention: 58,
    };

    // Keep current inputs and outpus as state to perform further calculations
    this.state = {
      population: 0,
      participation: 0,
      participants: 0,
      costPerParticipantTraditional: 0,
      annualCostSavings: 0,
      estimatedCostsTraditional: 0,
      estimatedCostsColor: 0,
      costPerPhysicianVisit: 0,
      numberOfPhysicianVisits: 0,
      bloodDrawFeeCost: 0,
      hga1cTestCost: 0,
      lipidPanelCost: 0,
      altTestCost: 0,
      astTestCost: 0,
      costPerParticipantHybridColor: 0,
      t2dAnnualExpectedCost: 0,
      t2dPotentialPopulationStopped: 0,
      t2dPopulationMakeUpCost: 0,
      hypertensionAnnualExpectedCost: 0,
      hypertensionPotentialPopulationStopped: 0,
      hypertensionMakeUpCost: 0,
    };

    // Move initial static value to state
    this.state.costPerParticipantHybridColor =
      parseFloat(this.initialValues.costPerParticipantHybridColor);

    // Event listeners
    this.population.addEventListener('input', this.performCalculations);
    this.participation.addEventListener('input', this.performCalculations);

    this.population.addEventListener('focusin', this.handleFocusIn);
    this.participation.addEventListener('focusin', this.handleFocusIn);

    this.population.addEventListener('focusout', this.handleFocusOut);
    this.participation.addEventListener('focusout', this.handleFocusOut);

    // Fill all empty fields
    this.fillInputs();

    // Trigger calculations on load
    this.performCalculations();
  }

  /**
   * Calculate the total participants and display it
   */
  calculateParticipants() {
    // Get values from inputs
    const populationNumber = parseInt(
      this.population.value.replace(this.digitsAndDots, '')
    );
    const participationNumber = parseFloat(
      this.participation.value.replace(this.digitsAndDots, '')
    ) / 100;
    console.log(participationNumber);


    // Validate values
    if (participationNumber > 1) {
      this.state.participation = 1;
      this.participation.value = '100%';
      this.performCalculations();
      return;
    }

    // If valid, update state and display calculation
    if (populationNumber >= 0 && participationNumber >= 0) {
      this.state.population = populationNumber;
      this.state.participation = participationNumber;
      this.state.participants = populationNumber * participationNumber;

      this.participants.value = this.state.participants.toLocaleString(
        'en-US',
        {
          style: 'decimal',
        }
      );
    }
  }

  /**
   * Fill in all inputs with initial values
   */
  fillInputs() {
    // Fill population
    this.population.value = parseFloat(this.initialValues.population).toLocaleString(
      'en-US',
      {style: 'decimal', maximumFractionDigits: 0}
    );

    // Fill participation
    this.participation.value = parseFloat(this.initialValues.participation).toLocaleString(
      'en-US',
      {
        style: 'percent',
        maximumFractionDigits: 2,
      }
    );

    // Fill additional detail inputs
    this.additionalDetailsFieldNames.forEach((fieldName) => {
      if (fieldName === 'numberOfPhysicianVisits') {
        this[fieldName].value = parseFloat(this.initialValues[fieldName]).toLocaleString('en-US', {style: 'decimal'});
      } else {
        this[fieldName].value = parseFloat(this.initialValues[fieldName]).toLocaleString(
          'en-US',
          {
            style: 'currency',
            currency: 'USD',
          }
        );
      }

      // Update state values
      this.state.population = parseFloat(
        this.population.value.replace(this.digitsAndDots, '')
      );
      this.state.participation = parseFloat(
        this.participation.value.replace(this.digitsAndDots, '')
      );
      this.state[fieldName] = parseFloat(
        this[fieldName].value.replace(this.digitsAndDots, '')
      );
    });
  }

  /**
   * Calculate the total cost
   */
  calculateTotalCost() {
    this.state.costPerParticipantTraditional =
      this.state.costPerPhysicianVisit * this.state.numberOfPhysicianVisits +
      this.state.bloodDrawFeeCost +
      this.state.hga1cTestCost +
      this.state.lipidPanelCost +
      this.state.altTestCost +
      this.state.astTestCost;

    // Display the cost
    if (!isNaN(this.state.costPerParticipantTraditional)) {
      this.costPerParticipantTraditional.value =
        this.state.costPerParticipantTraditional.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
    }
  }

  /**
   * Calculate the direct savings
   */
  calculateDirectSavings() {
    // Calculate estimated costs - traditional care model
    this.state.estimatedCostsTraditional =
      this.state.participants * this.state.costPerParticipantTraditional;

    // Display the cost
    if (!isNaN(this.state.estimatedCostsTraditional)) {
      this.estimatedCostsTraditional.innerText =
        this.state.estimatedCostsTraditional.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        });
    }

    // Calculate estimated costs - color essential care
    this.state.estimatedCostsColor =
      this.state.participants * this.state.costPerParticipantHybridColor;

    // Display the cost
    if (!isNaN(this.state.estimatedCostsColor)) {
      this.estimatedCostsColor.innerText =
      this.state.estimatedCostsColor.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      });
    }

    // Calculate the annual cost saving from color
    this.state.annualCostSavings =
      this.state.estimatedCostsTraditional - this.state.estimatedCostsColor;

    // Display the cost
    if (!isNaN(this.state.annualCostSavings)) {
      this.annualCostSavings.innerText =
        this.state.annualCostSavings.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        });
    }
  }

  /**
   * Calculate the Long Term ROI
   */
  calculateLongTermROI() {
    this.calculateT2D();
    this.calculateHypertension();
  }

  /**
   * Calculate the long term ROI from prediabetes and T2D
   */
  calculateT2D() {
    // Claculate the annual expected cost claims associated with employees who progress from prediabetes to T2D
    this.state.t2dAnnualExpectedCost =
      (this.state.participants *
        this.t2d.incidenceOfPrediabetes *
        this.t2d.averageProgressionOfPrediabetesToT2d *
        this.t2d.annualIncrementalCostOfTreatingT2d) /
      10000 /
      5;

    // Display the cost
    this.t2dCost.innerText = this.state.t2dAnnualExpectedCost.toLocaleString(
      'en-US',
      {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }
    );

    // Calculate the percentage of population that can be prevented from progressing from prediabetes to T2D in the first 5 years
    this.state.t2dPotentialPopulationStopped =
      (this.t2d.incidenceOfPrediabetes *
        this.t2d.averageProgressionOfPrediabetesToT2d *
        this.t2d.participationInDiabetesPrevention *
        this.t2d.effectivenessOfDiabetesPrevention) /
      100000000;

    // Calculate the percentage of prediabetes population that will make up the total annual program cost
    this.state.t2dPopulationMakeUpCost =
      this.state.estimatedCostsColor /
      this.t2d.annualIncrementalCostOfTreatingT2d /
      this.state.participants;

    // Display the amount
    if (isNaN(this.state.t2dPopulationMakeUpCost)) {
      this.t2dPercentage.innerText = 0;
    } else {
      this.t2dPercentage.innerText =
        (this.state.t2dPopulationMakeUpCost * this.state.participants).toLocaleString('en-US', {
          style: 'decimal',
          maximumFractionDigits: 0,
        });
    }
  }

  /**
   * Calculate the long term ROI from hypertension
   */
  calculateHypertension() {
    // Claculate the annual expected cost claims associated with employees who progress from prehypertension to hypertension
    this.state.hypertensionAnnualExpectedCost =
      (this.state.participants *
        this.hypertension.incidenceOfPrehypertension *
        this.hypertension.averageProgressionOfPreToHypertension *
        this.hypertension.annualIncrementalCostOfTreatingHypertension) /
      10000 /
      5;

    // Display the cost
    this.hypertensionCost.innerText =
      this.state.hypertensionAnnualExpectedCost.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      });

    // Calculate the percentage of population that can be prevented from progressing from prehypertension to hypertension in the first 5 years
    this.state.hypertensionPotentialPopulationStopped =
      (this.hypertension.incidenceOfPrehypertension *
        this.hypertension.averageProgressionOfPreToHypertension *
        this.hypertension.adherenceToCardiometabolicTxRegimen *
        this.hypertension.effectivenessOfHypertensionPrevention) /
      100000000;

    // Calculate the percentage of prehypertension population that will make up the total annual program cost
    this.state.hypertensionMakeUpCost =
      this.state.estimatedCostsColor /
      this.hypertension.annualIncrementalCostOfTreatingHypertension /
      this.state.participants;

    // Display the amount
    if (isNaN(this.state.hypertensionMakeUpCost)) {
      this.hypertensionPercentage.innerText = 0;
    } else {
      this.hypertensionPercentage.innerText =
        (this.state.hypertensionMakeUpCost * this.state.participants).toLocaleString('en-US', {
          style: 'decimal',
          maximumFractionDigits: 0,
        });
    }
  }

  /**
   * Perform all calculations
   *
   * @param {Object} e Event, if triggered by an event listener.
   */
  performCalculations(e) {
    // Check if if the calculations are triggered by an event
    if (e && e.target) {
      // If so, update the value on the state from the updated input (event target)
      this.state[e.target.id] = parseFloat(
        e.target.value.replace(this.digitsAndDots, '')
      );
    }

    // Trigger each calculation
    this.calculateParticipants();
    this.calculateTotalCost();
    this.calculateDirectSavings();
    this.calculateLongTermROI();
  }

  /**
   * Handler for focusing in of input
   *
   * @param {Object} e Focus out event
   */
  handleFocusIn(e) {
    e.target.value = e.target.value.replace(this.digitsAndDots, '');
  }

  /**
   * Handler for focusing out of input
   *
   * @param {Object} e Focus out event
   */
  handleFocusOut(e) {
    // Check if there's an event, a target, and an id
    if (e && e.target && e.target.id) {
      // Set constants
      const {id} = e.target;
      const options = {};

      // Set options for locale string depending on input
      if (id === 'population') {
        options.style = 'decimal';
        options.maximumFractionDigits = 0;
      } else if (id === 'participation') {
        options.style = 'percent';
        options.maximumFractionDigits = 2;
      } else if (id === 'numberOfPhysicianVisits') {
        options.style = 'decimal';
      } else {
        options.style = 'currency';
        options.currency = 'USD';
      }

      // Set formatted input value
      if (isNaN(this.state[id])) {
        e.target.value = parseFloat(this.initialValues[id]).toLocaleString(
          'en-US',
          options
        );
      } else {
        e.target.value = this.state[id].toLocaleString('en-US', options);
      }
    }
    this.performCalculations(e);
  }
}

const calculator = {
  init() {
    const calculatorContainer = document.querySelector('.calculator');

    if (calculatorContainer) {
      window.calculatorItem = new RoiCalculator(calculatorContainer);
    }
  },
};

export default calculator;
